export const CAMPAIGN_TYPE_OPTIONS = [
  { value: 1, label: "پیامک انبوه" },
  { value: 2, label: "لندینگ معرف" },
  { value: 3, label: "تماس تلفنی" },
  { value: 4, label: "رویداد" },
  { value: 5, label: "شبکه اجتماعی" },
  { value: 6, label: "منطقه‌ای" },
  { value: 7, label: "مشارکت نماینده" },
  { value: 8, label: "واردات دستی" },
];

export const CHANNEL_OPTIONS = [
  { value: 1, label: "پیامک" },
  { value: 2, label: "تلفن" },
  { value: 3, label: "اینستاگرام" },
  { value: 4, label: "تلگرام" },
  { value: 5, label: "واتساپ" },
  { value: 6, label: "وب‌سایت" },
  { value: 7, label: "رویداد" },
  { value: 8, label: "نماینده" },
  { value: 9, label: "دستی" },
];

export const GOAL_OPTIONS = [
  { value: 1, label: "ثبت‌نام" },
  { value: 2, label: "ثبت درخواست پروژه" },
  { value: 3, label: "مشاوره" },
  { value: 4, label: "استعلام وام" },
  { value: 5, label: "استعلام سیستم هیبریدی" },
  { value: 6, label: "سرمایه‌گذاری on-grid" },
];

export const CAMPAIGN_STATUS_OPTIONS = [
  { value: 1, label: "پیش‌نویس" },
  { value: 2, label: "زمان‌بندی‌شده" },
  { value: 3, label: "در حال اجرا" },
  { value: 4, label: "تکمیل‌شده" },
  { value: 5, label: "لغوشده" },
  { value: 6, label: "ناموفق" },
];

export const SEND_MODE_OPTIONS = [
  { value: 1, label: "کنترل‌شده (دسته‌ای)" },
  { value: 2, label: "خودکار (همه با هم)" },
];

export const SEND_STATUS_OPTIONS = [
  { value: 1, label: "در انتظار", color: "default" },
  { value: 2, label: "ارسال‌شده", color: "success" },
  { value: 3, label: "تحویل‌شده", color: "success" },
  { value: 4, label: "ناموفق", color: "error" },
  { value: 5, label: "رد شده", color: "warning" },
  { value: 6, label: "مسدود QA", color: "warning" },
  { value: 7, label: "محدودیت نرخ", color: "warning" },
];

export const getEnumLabel = (options, value) => {
  const match = options.find(
    (o) => String(o.value) === String(value) || String(o.label) === String(value)
  );
  return match?.label || "—";
};
